module.exports = __webpack_public_path__ + "img/robot2title.a6d93870.png";